export default __webpack_public_path__ + "static/ing-7fb17e96455f72eee9fad380d258f3d5.svg";